import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class UserNoteFilterEntity {
  user?: UserMiniEntity
  adminUser?: UserMiniEntity
  searchTerm?: string
  page?: number
  limit?: number
}
